import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { useRef } from 'react';

export const DemNetSalesPerspective = ({ forecastId }) => {

  const entityPerspectiveRef = useRef();

  const views = [
    {
      name: 'Full Breakout',
      dims: ['FORECAST', 'PROD', 'PERIOD', 'CHANNEL'],
      kpis: ['WAC', 'CHANNEL_ALLOC_PCT', 'CHANNEL_DISC_PCT', 'UNITS', 'WEIGHTED_DISC_PCT', 'CHANNEL_DISC_AMT', 'WEIGHTED_DISC_AMT', 'ANSP', 'GROSS_SALES', 'LIAB', 'NET_SALES'],
      dimsRearrangeable: false,
      dimToPeriodicities: {
        PERIOD: ['MON'],
      },
      disabledDims: ['FORECAST']
    }
  ]

  const defaultDimFilters = { FORECAST: [forecastId] };

  // TODO: With Units (Gross-to-Net)

  // const { openDialog } = useDialog();

  // const getContextMenuItems = (params) => {
  //   let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

  //   contextMenus.push({
  //     name: 'Adjust Channel Allocation',
  //     action: () => entityPerspectiveRef.current.overwrite(params, 'CHANNEL_ALLOCATION_PCT')
  //   });

  //   contextMenus.push({
  //     name: 'Adjust Discount Percentage',
  //     action: () => entityPerspectiveRef.current.overwrite(params, 'DISC_PCT')
  //   });

  //   contextMenus.push({
  //     name: 'Adjust WAC',
  //     action: () => {
  //       openDialog(ActionDialog, {
  //         title: 'WAC Overwrite',
  //         pluginCode: 'ADJUST_ACCR_RATE_ACTION_PLUGIN',
  //         entity: 'ACCR_RATE',
  //         addlReqData: {
  //           fetchReqParam: entityPerspectiveRef.current.buildReqParam(params),
  //           adjKpi: 'wac',
  //         },
  //       });
  //     },
  //   });

  //   contextMenus.push({
  //     name: 'Adjust Units',
  //     action: () => {
  //       openDialog(ActionDialog, {
  //         title: 'Units Overwrite',
  //         pluginCode: 'ADJUST_ACCR_RATE_ACTION_PLUGIN',
  //         entity: 'ACCR_RATE',
  //         addlReqData: {
  //           fetchReqParam: entityPerspectiveRef.current.buildReqParam(params),
  //           adjKpi: 'units',
  //         },
  //       });
  //     },
  //   });

  //   return contextMenus;
  // }

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      views={views}
      defaultDimFilters={defaultDimFilters}
      entity={'NET_SALES'}
    // gridOptions={{
    //   getContextMenuItems
    // }}
    />
  )
}